import { useSession } from '@hooks/useSession';

import Ethora from '@utils/messenger/ethora';

/**
 * Derives the unread chat message count for the current user from the
 * Ethora unread context and the session role.
 *
 * - PATIENT: total unread messages in their chat room
 * - ORG: number of chat rooms with unread messages
 * - OTHER: zero
 */
export function useUnreadCount() {
  const {
    state: { isPatient, isOrg },
  } = useSession();
  const {
    loading: unreadCountLoading,
    totalCount,
    unreadByRoom,
  } = Ethora.useUnreadMessages();

  /**
   * PATIENT: Total unread message in chat room
   * ORG: Total chat rooms with unread messages
   * OTHER: Zero
   */
  const unreadCount = isPatient
    ? totalCount
    : isOrg
      ? Object.keys(unreadByRoom).length
      : 0;

  return { unreadCount, unreadCountLoading };
}
